import React, { useMemo } from 'react';
import { Platform } from '../types/Platform';
import { Color } from '../types/Color';
import { GameOutcome } from '../types/GameOutcome';
import { Badge, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../store';
import { setParams } from '../reducers/paramsReducer';
import hasFilter from '../utils/hasFilter';
import { patternLabel } from './patternThemes';

function Filter(props: { children: React.ReactNode; onClose: () => void }): React.ReactNode {
  return (
    <Badge className="p-2 pt-1 pb-1 me-1 mb-1">
      {props.children}
      <Button className="btn-close" size="sm" onClick={() => props.onClose()}></Button>
    </Badge>
  );
}

export default function GamesAppliedFilters(): React.ReactNode {
  const params = useAppSelector((state) => state.paramsReducer.params);
  const {
    username,
    platform,
    color,
    result,
    opening,
    timeControl,
    from,
    to,
    ratingFrom,
    ratingTo,
    pattern,
    speed,
    pgn,
    onlyStarred,
    repair,
  } = params;
  const dispatch = useAppDispatch();

  const hasUsername = useMemo(
    () => params.username != null && params.username != '',
    [params.username]
  );
  const hasThem = hasFilter(params);

  if (!hasThem) {
    return null;
  }
  return (
    <div className="cm-applied-filters mb-1">
      <div className="cm-applied-filters-heading">Applied filters</div>
      <div className="d-flex flex-row flex-wrap">
      {hasUsername ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ username: null, color: null, result: null }));
          }}
        >
          {username}
        </Filter>
      ) : null}
      {onlyStarred === true ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ onlyStarred: null }));
          }}
        >
          ★ Favorites
        </Filter>
      ) : null}
      {repair != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ repair: null }));
          }}
        >
          {repair === 'never' ? 'never repaired' : 'not repaired lately'}
        </Filter>
      ) : null}
      {color != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ color: null }));
          }}
        >
          {color == Color.White ? 'played white' : 'played black'}
        </Filter>
      ) : null}
      {result != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ result: null }));
          }}
        >
          {result == GameOutcome.Won ? 'won' : 'lost'}
        </Filter>
      ) : null}
      {platform != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ platform: null }));
          }}
        >
          {platform == Platform.ChessCom
            ? 'Chess.com'
            : platform == Platform.Lichess
            ? 'Lichess'
            : null}
        </Filter>
      ) : null}
      {opening != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ opening: null }));
          }}
        >
          {opening}
        </Filter>
      ) : null}
      {timeControl != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ timeControl: null }));
          }}
        >
          {timeControl}
        </Filter>
      ) : null}
      {from != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ from: null }));
          }}
        >
          {from}
        </Filter>
      ) : null}
      {to != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ to: null }));
          }}
        >
          {to}
        </Filter>
      ) : null}
      {ratingFrom != null || ratingTo != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ ratingFrom: null, ratingTo: null }));
          }}
        >
          Rating {ratingFrom ?? '0'}–{ratingTo ?? '∞'}
        </Filter>
      ) : null}
      {pattern != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ pattern: null }));
          }}
        >
          {patternLabel(pattern) ?? pattern}
        </Filter>
      ) : null}
      {speed != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ speed: null }));
          }}
        >
          {speed}
        </Filter>
      ) : null}
      {pgn != null ? (
        <Filter
          onClose={() => {
            dispatch(setParams({ pgn: null }));
          }}
        >
          Line: {pgn}
        </Filter>
      ) : null}
      </div>
    </div>
  );
}
